import { component } from 'picoapp';
import { gsap, Linear } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

export default component(async (node) => {
  gsap.registerPlugin(ScrollTrigger);

  const { type } = node.dataset;
  const images = node.querySelectorAll<HTMLImageElement>('[data-image]');

  const initCenter = () => {
    const timeline = gsap.timeline({
      scrollTrigger: {
        trigger: node,
        start: 'top top',
        // end: 'bottom bottom',
        end: `+=${window.innerHeight * 2.5}`,
        scrub: true,
        pin: true,
      },
    });

    const positionDataset = [
      {
        0: {
          x: 404,
          y: -280,
        },
        992: {
          x: 404,
          y: -322,
        },
      },
      {
        x: -452,
        y: -125,
      },
      {
        0: {
          x: -254,
          y: -262,
        },
        992: {
          x: -254,
          y: -352,
        },
      },
      {
        0: {
          x: 510,
          y: -50,
        },
        992: {
          x: 510,
          y: -30,
        },
      },
      {
        x: 440,
        y: 224,
      },
      {
        0: {
          x: -500,
          y: 260,
        },
        992: {
          x: -500,
          y: 224,
        },
      },
    ]

    const getDataset = (index = 0) => {
      const windowWidth = window.innerWidth;
      const dataset = positionDataset[index];

      const breakpoints = Object.keys(dataset).map((breakpoint) => parseInt(breakpoint, 10));
      const hasValidBreakpoints = breakpoints.every((breakpoint) => !Number.isNaN(breakpoint))

      if (hasValidBreakpoints) {
        const nearestBreakpoint = breakpoints.reduce((a, b) => Math.abs(b - windowWidth) < Math.abs(a - windowWidth) ? b : a);

        return {
          bp: nearestBreakpoint,
          ...dataset[nearestBreakpoint],
        }
      }

      return dataset;
    }

    images.forEach((image, index) => {
      const delay = Math.random();
      const { x, bp } = getDataset(index);

      /* eslint-disable no-return-assign */
      const setPosition = (value, position = 'x') => {
        if (bp >= 0) {
          return positionDataset[index][bp][position] = value;
        }

        return positionDataset[index][position] = value;
      }

      const limitPosition = () => {
        if (x > (window.innerWidth / 2)) {
          setPosition((window.innerWidth / 2), 'x');
        }

        if (x < -(window.innerWidth / 2)) {
          setPosition(-(window.innerWidth / 2) + 80, 'x');
        }
      }

      limitPosition();

      const getPosition = (position = 'x') => {
        if (bp >= 0) {
          return positionDataset[index][bp][position];
        }

        return positionDataset[index][position];
      }

      timeline.to(image, {
        x: getPosition('x'),
        y: getPosition('y'),
        ease: Linear.easeInOut,
        scale: 0.4,
        delay,
      }, 0);
    });
  };

  const initNormal = () => {
    const timeline = gsap.timeline({
      scrollTrigger: {
        trigger: node,
        start: 'top top',
        // end: 'bottom bottom',
        end: `+=${window.innerHeight * 2.5}`,
        scrub: true,
        pin: true,
      },
    });

    // Append images to timeline in reverse order
    [...images].reverse().slice(0, -1).forEach((image) => {
      timeline.to(image, {
        y: -window.innerHeight,
        ease: Linear.easeInOut,
      });
    });
  }

  const init = () => {
    if (type === 'center') {
      initCenter();
    } else {
      initNormal();
    }
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        init();
        observer.unobserve(node);
      }
    });
  });

  observer.observe(node);
});
